export default "/images/icon-ai-video.gif?9e1efde5ee824331958f61dc25a227bb";